import superagent from 'superagent';
import getCookie from './getCookie';
import webservice from './webservice';

export default async function GetCatalogoRegimenFiscal() {
  let url = `${webservice}/GetCatalogoRegimenFiscal`;

  let response = {};

  await superagent
    .get(url)
    .set(('Content-Type': 'application/json'))
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body.GetCatalogoRegimenFiscalResult;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        typeMessage: 'error',
        message: 'Error',
      };
      response = resp;
    });

  return response;
}
